import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const StockAlerts = ({ alerts, onRestock }) => {
  if (!alerts || alerts?.length === 0) return null;

  return (
    <div className="bg-warning/10 border border-warning/20 rounded-lg p-4 mb-6">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="AlertTriangle" size={20} className="text-warning" />
        <h3 className="font-semibold text-foreground">Alertes de réapprovisionnement ({alerts?.length})</h3>
      </div>
      <div className="space-y-2">
        {alerts?.map((alert) => (
          <div
            key={alert?.id}
            className="bg-card rounded-lg p-3 flex items-center justify-between"
          >
            <div className="flex-1">
              <div className="flex items-center gap-2">
                <span className="font-medium text-foreground">{alert?.consumables?.name}</span>
                <span className="text-xs px-2 py-1 rounded bg-warning/20 text-warning">
                  Stock: {alert?.current_stock}
                </span>
              </div>
              <p className="text-sm text-muted-foreground mt-1">
                Seuil minimum: {alert?.minimum_threshold} - Créée le {new Date(alert?.created_at)?.toLocaleDateString('fr-FR')}
              </p>
            </div>
            <Button
              variant="default"
              size="sm"
              iconName="Plus"
              onClick={() => onRestock(alert?.consumables)}
            >
              Réapprovisionner
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StockAlerts;